import { functions } from '@/functions';

export const functions_room = {
    mixins: [functions],
    data: function () {
        return {
            room:null,
            rooms:[],
        }
    },

    methods: {

        loadRooms: function (hotel_id, onSuccess=null, param=null) {
            if (!this.isRoomsLoaded() && hotel_id) {
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/rooms/a')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.rooms = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetRooms: function () {
            this.rooms = [];
            return this;
        },

        isRoomsLoaded: function () {
            return this.is(this.rooms) && this.rooms.length;
        },

        getRoomById: function (id, rooms = null) {
            if (!this.is(id)) {
                return null;
            }

            if (rooms === null) {
                rooms = this.rooms;
            }

            for (let i = 0; i < rooms.length; i++) {
                if (rooms[i].id === id) {
                    return rooms[i];
                }
            }
            return null;
        },

        getRoomTitleById: function (id, rooms=null) {
            if (!this.is(id)) {
                return 'не указано';
            }

            if (rooms===null) {
                rooms = this.rooms;
            }

            for (let i=0; i<rooms.length; i++) {
                if (rooms[i].id === id) {
                    return rooms[i].title;
                }
            }
            return 'room непонятка (#'+id+')';
        },

        loadRoomPrivate: function (room_id, onSuccess=null, param=null) {
            if (!this.is_room_loaded && room_id) {
                this.room = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('room/' + room_id + '/private')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.room = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadRoom: function (room_id, onSuccess=null, param=null) {
            if (!this.is_room_loaded && room_id) {
                this.room = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('room/' + room_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.room = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetRoom: function () {
            this.room = null;
            return this;
        },

        enableRoom: function (room_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('room/' + room_id + '/enable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disableRoom: function (room_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('room/' + room_id + '/disable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        deleteRoom: function (room_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('room/' + room_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        createRoom: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('room/create/' + hotel_id  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestRoom(response.payload.id);
            }, this.httpError)
        },

        cloneRoom: function (room_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('room/' + room_id + '/clone'  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestRoom(response.payload.id);
            }, this.httpError)
        },

        delRoomById: function (id, rooms = null) {
            if (!this.is(id)) return false;
            if (rooms === null) rooms = this.rooms;

            for (let i = 0; i < rooms.length; i++) {
                if (rooms[i].id === id) {
                    rooms.splice(i, 1);
                    return true;
                }
            }
            return false;
        },

        saveRoom: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('room/'+this.room.id+'/save'), this.room).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                this.setLatestRoom(this.room.id);
            }, this.httpError)
        },

        latestRoomClass: function (room) {
            return this.isLatest('App\\Models\\Room', room.id) ? 'latest' : '';
        },
        setLatestRoom: function (id) {
            this.setLatest('App\\Models\\Room', id);
        },

    },
    computed: {
        is_room_loaded: function () {
            return (this.room !== null) && this.room;
        },

        booker_room_id: {
            set: function (val) {
                this.room.prof_obj_rooms_id = val;
            },
            get: function () {
                return this.room.prof_obj_rooms_id;
            },
        },
    }
};



